import numeral from "numeral";
const getNumberText = (number) => {
  const result = numeral(number).format("(0.00 a)");
  const [value, unit] = result.split(" ");
   return {
    value,
    unit,
  };
};

export default getNumberText;
